import { StepConfig } from '../model/step-config.model';

export const STEPS_DIRECT_CONFIG: StepConfig = [
  {
    label: 'progress-stepper-labels.step1',
    route: '/page/step1',
    index: 0,
    progress: 0.5,
  },
  {
    label: 'progress-stepper-labels.step1',
    route: '/page/step2',
    index: 0,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.step2',
    route: '/page/step3',
    index: 1,
    progress: 0.5,
  },
  {
    label: 'progress-stepper-labels.step2',
    route: '/page/step4',
    index: 1,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.step3',
    route: '/page/step5',
    index: 2,
    progress: 0.25,
  },
  {
    label: 'progress-stepper-labels.step3',
    route: '/page/step6',
    index: 2,
    progress: 0.5,
  },
  {
    label: 'progress-stepper-labels.step3',
    route: '/page/payment',
    index: 2,
    progress: 0.75,
  },
  {
    label: 'progress-stepper-labels.step4',
    route: '/page/success',
    index: 3,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id',
    index: 0,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/otp',
    index: 1,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/consents',
    index: 2,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/payment',
    index: 3,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/success',
    index: 4,
    progress: 1,
  },
];

export const STEPS_DIRECT_CONFIG_FOR_TRACKING: StepConfig = [
  {
    label: 'step-labels-for-tracking.step1',
    route: '/page/step1',
    index: 0,
    progress: 0.5,
  },
  {
    label: 'step-labels-for-tracking.step2',
    route: '/page/step2',
    index: 0,
    progress: 1,
  },
  {
    label: 'step-labels-for-tracking.step3',
    route: '/page/step3',
    index: 1,
    progress: 0.5,
  },
  {
    label: 'step-labels-for-tracking.step4',
    route: '/page/step4',
    index: 1,
    progress: 1,
  },
  {
    label: 'step-labels-for-tracking.step5',
    route: '/page/step5',
    index: 2,
    progress: 0.25,
  },
  {
    label: 'step-labels-for-tracking.step6',
    route: '/page/step6',
    index: 2,
    progress: 0.5,
  },
  {
    label: 'step-labels-for-tracking.payment',
    route: '/page/payment',
    index: 2,
    progress: 0.75,
  },
  {
    label: 'step-labels-for-tracking.success',
    route: '/page/success',
    index: 3,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id',
    index: 0,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/otp',
    index: 1,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/consents',
    index: 2,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/payment',
    index: 3,
    progress: 1,
  },
  {
    label: 'progress-stepper-labels.remote',
    route: '/remote/:id/success',
    index: 4,
    progress: 1,
  },
];
